<div class="pane-container">
  <app-locality-overview title="Localities" (selection)="onShortcut($event)"></app-locality-overview>
  <app-action-pane domain="LOCATIONS" [hint]="['Identifier', 'Name']" (action)="onAction($event)"
    (magic)="onSearch({ magic: $event})"></app-action-pane>
</div>
<div *ngIf="creation; then showForm else showList"></div>
<ng-template #showForm>
  <app-locality-form [creation]="true" [mode]="Mode.edition" [object]="locality" (event)="onEvent($event)"></app-locality-form>
</ng-template>
<ng-template #showList>
  <app-locality-list #list [sorting]="sorting" (event)="onEvent($event)" (sort)="onSort($event)"></app-locality-list>
</ng-template>
